<div class="card-container">
  <div class="image">
    <img src="../../../../assets/svgs/{{card.image}}.svg" alt="card-image">
  </div>
  <div class="body">
    <span class="title">{{card.title}}</span>
    <span class="message">{{card.message}}</span>
  </div>
</div>